import React from 'react';
import JobFormPage from '../JobFormPage';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import { client } from 'shared';
import { BusinessJobTemplateDetailsDTO } from 'parent-portal/forms/JobTemplateModels';
import { toJobFormPresets } from 'parent-portal/forms/JobFormPresets';
import { TemplateOption } from 'parent-portal/forms/JobRequestTypes';
import JobTemplateListContent from './JobTemplateListContent';

export default function SelectTemplatePage({ name }: { name: string }) {
    const { goToNext, form, setPresets, reset, setDatesConfirmed } = useJobFormContext();
    const { templateJobId, address, businessJobType, endDate } = form.fieldStates;
    const trialRun = businessJobType.value === 'TRIAL_RUN';
    const selectedSpotlightWorkers = form.fieldStates.selectedSpotlightWorkers.value;
    const allSpotlightWorkers = form.fieldStates.allSpotlightWorkers.value;

    function handleAddressChange(value: number) {
        address.setValue([{ id: value }]);
    }

    function handleSelectJobTemplate(value?: number) {
        templateJobId.setValue(value);
        setDatesConfirmed(false);
    }

    async function duplicateAndGoToNext() {
        if (!templateJobId) return;
        reset({
            useTemplate: TemplateOption.TEMPLATE,
            businessJobType: businessJobType.value,
            selectedSpotlightWorkers,
            allSpotlightWorkers,
        });
        client(`api/job-template/${templateJobId.value}/`).then((resp: BusinessJobTemplateDetailsDTO) => {
            setPresets({
                ...toJobFormPresets(resp),
                multipleProviders: !trialRun,
                startDate: null,
                endDate: null,
            });
            if (trialRun) {
                endDate.setValue(null);
            }
            goToNext(name);
        });
    }

    return (
        <JobFormPage
            title="Choose previous job post for template"
            onNextClicked={duplicateAndGoToNext}
            nextDisabled={!templateJobId}
            id={name}
        >
            <JobTemplateListContent
                address={address.value?.length > 0 ? address.value[0].id : null}
                setAddress={handleAddressChange}
                selectedJobId={templateJobId.value}
                setSelectedJobId={handleSelectJobTemplate}
            />
        </JobFormPage>
    );
}
